import { render } from "./counter.vue?vue&type=template&id=37ca3a9b"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__